import {useI18n} from 'i18n/I18nContext'
import React from 'react'
import styled from 'styled-components'

export const InfoSection = () => {
  const {t} = useI18n()
  return (
    <InfoSectionHolder>
      <h4>{t('orgCsv.guideTitle')}</h4> <br />
      <p>{t('orgCsv.guideIntro')}</p>
      <ul>
        <li>{t('orgCsv.guideLi1')}</li>
        <li>{t('orgCsv.guideLi2')}</li>
        <li>{t('orgCsv.guideLi3')}</li>
        <li>{t('orgCsv.guideLi4')}</li>
        <li>{t('orgCsv.guideLi5')}</li>
      </ul>
    </InfoSectionHolder>
  )
}

const InfoSectionHolder = styled.div`
  margin-top: 30px;
  background: #f8f9fa;
  padding: 20px;
  border-radius: 10px;

  h3 {
    margin-bottom: 10px;
    color: #202124;
  }
  p {
    margin-bottom: 12px;
    color: #3c4043;
  }
  ul {
    list-style: disc;
    padding-left: 20px;
    li {
      margin-bottom: 6px;
      color: #5f6368;
    }
  }
`
